import { Stack } from "@mui/material";
import * as React from "react";
import type { Sizing, TemplateItemInterface } from "src/components/template/types";
import { useTemplateDrawer } from "src/components/providers/template-drawer-provider";

const TemplateItemEditOverlay = ({
    isChart,
    item,
    templateIndex,
    rowIndex,
    itemIndex,
}: {
    isChart: boolean;
    item: TemplateItemInterface | { sizing: Sizing };
    templateIndex: number;
    rowIndex: number;
    itemIndex: number;
}) => {
    const { drawerOpen, setDrawerOpen, setOnEditItem, onEditItem } = useTemplateDrawer();
    const [mouseIn, setMouseIn] = React.useState(false);
    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            style={{
                backgroundColor: "#474747",
                position: "absolute",
                zIndex: 101,
                opacity: 0.8,
                inset: 0,
                marginTop: isChart ? "8px" : 0,
                marginLeft: isChart ? "8px" : 0,
                cursor: "pointer",
                ...((mouseIn ||
                    (drawerOpen &&
                        onEditItem?.itemIndex === itemIndex &&
                        onEditItem?.rowIndex === rowIndex &&
                        onEditItem?.templateIndex === templateIndex)) && {
                    borderColor: "#60D297",
                    borderWidth: "2px",
                    borderStyle: "dashed",
                }),
            }}
            onMouseEnter={() => {
                setMouseIn(true);
            }}
            onMouseLeave={() => {
                setMouseIn(false);
            }}
            onClick={() => {
                setOnEditItem({
                    isChart,
                    item,
                    templateIndex,
                    rowIndex,
                    itemIndex,
                });
                setDrawerOpen(true);
            }}
        >
            <span style={{ fontSize: "1rem", paddingTop: "10px", fontWeight: "300" }}>
                {drawerOpen &&
                onEditItem?.itemIndex === itemIndex &&
                onEditItem?.rowIndex === rowIndex &&
                onEditItem?.templateIndex === templateIndex
                    ? "Editing"
                    : `${"id" in item ? "Click to Edit" : "Click to Add"}`}
            </span>
        </Stack>
    );
};

export default TemplateItemEditOverlay;
